import CircularProgress from '@ahamove/web-components/lib/CircularProgress';
import Stack from '@ahamove/web-components/lib/Stack';
import Typography from '@ahamove/web-components/lib/Typography';
import { EmptyRecordIcon } from '@/lib/icons';
import useIsMobile from '@/shared-hooks/useIsMobile';

type Props = {
  title?: string;
  loading?: boolean;
};

export default function EmptyRecord({
  title = 'Hiện tại bạn chưa có đơn đặt hàng nào',
  loading,
}: Props) {
  const isMobile = useIsMobile();

  return (
    <Stack
      data-test-id="emptyRecordContainer"
      direction="column"
      spacing={isMobile ? 2 : 2.75}
      justifyContent="center"
      alignItems="center"
      mx="auto"
      px={isMobile ? 2 : 5}
      py={isMobile ? 8 : 10.625}
    >
      <EmptyRecordIcon />
      {loading ? (
        <CircularProgress color="secondary" />
      ) : (
        <Typography variant="h4" color="grey.500" textAlign="center">
          {title}
        </Typography>
      )}
    </Stack>
  );
}
